// @flow

import React from 'react';
import _ from 'lodash';
import cx from 'classnames';

type Props = {
  className: string,
  title: string,
  items: Array<{
    imgSrc: string,
    alt: string,
    header: string,
    text: string,
  }>,
};

// images might have different height in their original format,
// set the maxHeight to ensure they will always have the same height
const ICON_FIXED_HEIGHT = '90px';

const BenefitSection = (props: Props) => {
  const { title = '', items = [], className = '' } = props;
  if (_.isEmpty(items)) return null;

  return (
    <section className={cx('benefits-section', className)}>
      {title && <h2 className="benefits-section-title text-center">{title}</h2>}
      <div className="row">
        {!_.isEmpty(items) &&
          items.map((benefit, idx) => (
            <div className="column medium-4" key={_.get(benefit, 'imgSrc', idx)}>
              <div className="benefit">
                <img
                  src={_.get(benefit, 'imgSrc')}
                  alt={_.get(benefit, 'alt')}
                  style={{ height: ICON_FIXED_HEIGHT }} />
                <h3 className="pad-top">{_.get(benefit, 'header')}</h3>
                <p className="pad-top-half">{_.get(benefit, 'text')}</p>
              </div>
            </div>
          ))}
      </div>
    </section>
  );
};

export default BenefitSection;
